<p-popover #op appendTo="body" styleClass="quick-access-panel" (onShow)="panelToggle.emit(true)" (onHide)="panelToggle.emit(false)">
    <div class="quick-access-grid">
        <a class="quick-access-item" *ngFor="let item of items" [href]="item.url" target="_blank">
            <div [style.background-image]="'url(' + item.icon + ')'" class="quick-access-icon"></div>
            <span>{{ item.name | translate }}</span>
        </a>
    </div>
</p-popover>
